import React, { useEffect, useState } from "react";
import {
  CancelButton,
  CreateButton,
  ExportButton,
  FilterButton,
  ImportButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
// import UseGetData from "../../../../Components/Hooks/useFetchData";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
// import MoreOptions from "../../../../Components/Utils/MoreOptions";
// import CustomDataTable from "../../../../Components/Others/CustomDataTable";
// import Card from "../../../../Components/Icons/card";
// import List from "../../../../Components/Icons/list";
import Select from "react-select";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
// import SupplierCard from "./SupplierCard";
// import Pagination from "../../../../Components/Utils/Pagenation";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from "yup";
// import { NuInput } from "../../../../Components/Utils/Input";
// import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import { CountryMIN } from "../../../../assets/CountryMini";
import Importdoc from "./Importdoc";
// import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import useFetchMetaStarIndex from "../../../../Components/Hooks/useFetchMetaStarIndex";
import MultiEdit from "./MultiEdit";
import axiosInstance from "../../../../Services/axiosCommon";
import CloseIcon from "../../../../Components/Icons/Close";
import DataFormat from "../../../../Components/Utils/NuDate";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import PremiumTable from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import ViewToggle from "../../../../Components/Utils/ViewToggle";

// Supplier Table Row Component
const SupplierTableRow = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/vendors/" + `${row.vendorId}`, setIsModalOpen);
  return (
    <>
      <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
        {/* Checkbox */}
        <td className="p-4 text-center align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
        </td>

        {/* ID */}
        <td className="p-4 text-center align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-500">
          {row.vendorId}
        </td>

        {/* Company */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 font-semibold text-sm text-gray-800 min-w-[220px]">
          <div className="flex items-center gap-2 flex-wrap">
            <Link
              to={`/procurement/suppliers/view/${row.vendorId}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="hover:underline text-sm font-bold text-gray-800 whitespace-nowrap"
            >
              {row.companyName || "N/A"}
            </Link>
            {Boolean(
              row?.isBlacklisted ||
              row?.blacklisted ||
              row?.isBlacklist ||
              row?.is_blacklisted
            ) && (
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold bg-rose-50 text-rose-600 border border-rose-200 whitespace-nowrap">
                  Blacklisted
                </span>
              )}
          </div>
        </td>

        {/* Category */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 min-w-[160px] whitespace-nowrap">
          {row.category || "N/A"}
        </td>

        {/* Country */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {row.country || "N/A"}
        </td>

        {/* Contact Person */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {row.contactPerson || "N/A"}
        </td>

        {/* Mobile */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
          {row.phoneWithCC || "N/A"}
        </td>

        {/* Email */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-500 whitespace-nowrap">
          {row.email || "N/A"}
        </td>

        {/* Created By */}
        <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-500 whitespace-nowrap">
          {row.createdByName || "N/A"}
        </td>

        {/* Action Buttons */}
        <td className="p-4 text-center align-middle border-t border-b border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
          <div className="flex items-center justify-center gap-1.5">
            {/* View */}
            <Link
              to={`/procurement/suppliers/view/${row.vendorId}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="View details"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </Link>
            {/* Edit */}
            {CheckEditAction(row, "Suppliers", canEdit) && (
              <Link
                to={`/procurement/suppliers/edit/${row.vendorId}`}
                state={{
                  data: row,
                  from: "/procurement/suppliers",
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Edit supplier"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
              </Link>
            )}
            {/* Delete */}
            {CheckDeleteAction(row, canDelete) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
                title="Delete supplier"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            )}
          </div>
        </td>
      </tr>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.companyName || row.vendorId} will be removed from Suppliers!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

// Supplier Card Wrapper Component
const SupplierCardWrapper = ({
  row,
  isSelected,
  onSelect,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/vendors/" + `${row.vendorId}`, setIsModalOpen);
  const isBlacklisted = Boolean(
    row?.isBlacklisted ||
    row?.blacklisted ||
    row?.isBlacklist ||
    row?.is_blacklisted
  );
  return (
    <div className={`relative border border-y-gray-200/50 border-r-gray-200/50 border-l-0 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-5 flex flex-col gap-4 overflow-hidden ${isBlacklisted
      ? "border-l-4 border-l-rose-500"
      : "border-l-4 border-l-emerald-500"
      }`}>
      {/* Card Header */}
      <div className="flex justify-between items-start gap-4">
        <div className="flex items-center gap-2.5">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={onSelect}
            className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer"
          />
          <div className="flex flex-col">
            <Link
              to={`/procurement/suppliers/view/${row.vendorId}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="text-gray-800 font-bold hover:underline text-sm truncate max-w-[180px]"
            >
              {row.companyName || "N/A"}
            </Link>
            <span className="text-[10px] text-gray-400 font-bold mt-0.5">ID: #{row.vendorId}</span>
          </div>
        </div>

        <div className="flex items-center gap-1.5 flex-wrap justify-end">
          {isBlacklisted && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold bg-rose-50 text-rose-600 border border-rose-200">
              Blacklisted
            </span>
          )}
          {/* Status indicator */}
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.vendorStatus === "Active"
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : "bg-red-50 text-red-700 border-red-100"
            }`}>
            {row.vendorStatus || "N/A"}
          </span>
        </div>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex flex-col gap-2 text-xs">
        <div className="flex justify-between items-center">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Category</span>
          <span className="font-bold text-gray-700">{row.category || "--"}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Country</span>
          <span className="font-bold text-gray-700">{row.country || "--"}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Contact Person</span>
          <span className="font-bold text-gray-700">{row.contactPerson || "--"}</span>
        </div>
      </div>

      {/* Contact Details */}
      <div className="flex flex-col gap-1.5 px-1 text-xs text-gray-600 font-medium">
        {row.email && (
          <div className="flex justify-between items-center gap-2">
            <span>Email:</span>
            <span className="font-semibold text-gray-800 truncate max-w-[180px]">{row.email}</span>
          </div>
        )}
        {row.phoneWithCC && (
          <div className="flex justify-between items-center gap-2">
            <span>Phone:</span>
            <span className="font-semibold text-gray-800">{row.phoneWithCC}</span>
          </div>
        )}
      </div>

      {/* Action Buttons Row */}
      <div className="flex items-center justify-between gap-1.5 border-t border-gray-100 pt-3 mt-1 flex-wrap sm:flex-nowrap">
        <Link
          to={`/procurement/suppliers/view/${row.vendorId}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
          title="View Details"
        >
          <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="hidden sm:inline">View Details</span>
        </Link>
        <div className="flex items-center gap-1.5">
          {CheckEditAction(row, "Suppliers", canEdit) && (
            <Link
              to={`/procurement/suppliers/edit/${row.vendorId}`}
              state={{
                data: row,
                from: "/procurement/suppliers",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Edit"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              <span className="hidden sm:inline">Edit</span>
            </Link>
          )}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
              title="Delete"
            >
              <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              <span className="hidden sm:inline">Delete</span>
            </button>
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.companyName || row.vendorId} will be removed from Suppliers!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

function SuppliersIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("viewMode") === "list" ? "table" : localStorage.getItem("viewMode") || "card"
  );
  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;
  const [searchBy, setSearchBy] = useState("all");
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const { data: user } = UseDropDown("/user/drop-down");
  const { value: vendorRating } = useFetchMetaStarIndex(
    `/dropdown/dropdown-details/`,
    "vendorRating_supplier",
    showFilterDialog || showExport,
  );
  const { value: vendorStatus } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "status_supplier",
    showFilterDialog || showExport,
  );
  const { value: vendorType } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "SupplierType",
    showFilterDialog || showExport,
  );
  const { value: supplierCat } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "SupplierCategory",
    showFilterDialog || showExport,
  );

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const [filterProps, setFilterProps] = useState({
    country: "",
    createdBy: "",
    // isGeneral: "",
    vendorStatus: "",
    performanceRating: "",
    vendorType: "",
    category: "",
    assigned_to: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    searchBy: "",
    country: "",
    createdBy: "",
    // isGeneral: "public",
    vendorStatus: "",
    performanceRating: "",
    category: "",
    vendorType: "",
    assigned_to: "",
  });

  useEffect(() => {
    if (searchQuery) {
      setParams({ ...params, search: searchQuery });
    }
  }, [searchQuery]);

  const clearFilter = () => {
    setParams({
      ...params,
      country: "",
      vendorStatus: "",
      createdBy: "",
      // isGeneral: "",
      performanceRating: "",
      category: "",
      vendorType: "",
      assigned_to: "",
    });
    formik.values.performanceRating = "";
    formik.values.vendorStatus = "";
    formik.values.country = "";
    formik.values.createdBy = "";
    // formik.values.isGeneral = "";

    formik.values.vendorType = "";
    formik.values.category = "";
    formik.values.assigned_to = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({
        ...params,
        performanceRating: value.performanceRating,
        vendorStatus: value.vendorStatus,
        country: value.country,
        createdBy: value.createdBy,
        // isGeneral: value.isGeneral,
        category: value.category,
        vendorType: value.vendorType,
        assigned_to: value.assigned_to,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        country: "",
        vendorStatus: "",
        createdBy: "",
        // isGeneral: "",
        performanceRating: "",
        vendorType: "",
        category: "",
        assigned_to: "",
      });
    },
  });

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  const { data, totalCount, getData, credit, advance, dataLoading } =
    UseGetDataSearch("/vendors/search", params);

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.vendorId);
      });
    setFullList(tempArr);
  }, [data]);

  const canEdit = GetAccess("suppliers_edit") || GetRole();
  const canDelete = GetAccess("suppliers_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  const defaultHeader = [
    {
      title: "ID",
      width: "5%",
      field: "vendorId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Company ",
      width: "10%",
      isLink: true,
      id: "vendorId",
      link: "/procurement/suppliers/view/",
      field: "companyName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Location",
      width: "10%",
      field: "city",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Contact Person",
      width: "10%",
      field: "contactPerson",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Mobile",
      width: "10%",
      field: "phoneWithCC",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Email",
      width: "10%",
      field: "email",
      type: "email",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Created By",
      width: "10%",
      field: "createdByName",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Private / Public",
    //   width: "10%",
    //   field: "type",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Assigned To",
      width: "10%",
      field: "assignedToName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        id: "vendorId",
        removeValue: "Vendors",
        url: "/vendors/",
        moduleName: "Suppliers",
        from: "/procurement/suppliers",
        editLink: "/procurement/suppliers/edit/",
        viewLink: "/procurement/suppliers/view/",
      },
    },
  ];

  let availableHeaders = [
    {
      title: "ID",
      width: "5%",
      field: "vendorId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Company ",
      width: "15%",
      isLink: true,
      id: "vendorId",
      link: "/procurement/suppliers/view/",
      field: "companyName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Location",
      width: "10%",
      field: "city",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Contact Person",
      width: "10%",
      field: "contactPerson",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Mobile",
      width: "10%",
      field: "phoneWithCC",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Email",
      width: "10%",
      field: "email",
      type: "email",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Created By",
      width: "10%",
      field: "createdByName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Website",
      width: "10%",
      field: "website",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Assigned To",
      width: "10%",
      field: "assignedToName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Designation",
      width: "10%",
      field: "designation",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Building No",
      width: "10%",
      field: "buildingNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Contact Person Email",
      width: "10%",
      field: "contactPersonEmail",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Contact Person No.",
      width: "10%",
      field: "contactPersonMobile.display",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Tax",
      width: "10%",
      field: "taxId",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Street",
      width: "10%",
      field: "streetName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Country",
      width: "10%",
      field: "country",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "State",
      width: "10%",
      field: "state",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "District",
      width: "10%",
      field: "district",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Postal Code",
      width: "10%",
      field: "postalCode",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Comments",
    //   width: "10%",
    //   field: "comments",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher: getData,
        id: "vendorId",
        removeValue: "Vendors",
        url: "/vendors/",
        moduleName: "Suppliers",
        from: "/procurement/suppliers",
        editLink: "/procurement/suppliers/edit/",
        viewLink: "/procurement/suppliers/view/",
      },
    },
  ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "33px",
      height: "33px",
      fontSize: "12px",
      minWidth: "100px",
      width: "100px",
      borderRadius: "8px",
      border: "none",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: "4px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0 8px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    singleValue: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
    { value: "products", label: "Products" },
  ];

  function handleSearch(e) {
    setSearchBy(e.value);
    setParams({ ...params, searchBy: e.value });
  }

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
    localStorage.setItem("viewMode", viewMode);
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  const [exportValue, setExportValue] = useState({
    country: "",
    vendorStatus: "",
    performanceRating: "",
    vendorType: "",
    createdBy: "",
    category: "",
    type: "all",
    assigned_to: "",
  });

  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      try {
        const response = await axiosInstance.get(
          `/vendors/export-to-excel?country=${value.country}&performanceRating=${value.performanceRating}&vendorType=${value.vendorType}&vendorStatus=${value.vendorStatus}&createdBy=${value.createdBy}&category=${value.category}&assigned_to=${value.assigned_to}`,
          {
            responseType: "blob", // Important to specify the response type as blob
          },
        );

        // Create a Blob from the response
        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link element

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        link.download = `CQ Report ${DataFormat({
          value: new Date(),
          format: "DD-MMM-YYYY",
        })}.xlsx`; // The filename you want for the downloaded file

        // Append the link to the body (required for Firefox)
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    },
  });




  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.vendorId);
      });
    setFullList(tempArr);
  }, [data]);



  return (
    <div className="w-full h-full px-2 sm:px-4 py-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[{ name: "Procurement" }, { name: "Suppliers" }]}
          />
          <div className="flex md:hidden items-center gap-1.5 flex-wrap">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetRole() && (
              <ExportButton handleClick={() => setShowExport(true)} />
            )}
            {GetRole() && <ImportButton handleClick={handleImportClick} />}
            {GetAccess("suppliers_create") && (
              <Link to="/procurement/suppliers/create/">
                <CreateButton label="Supplier" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center justify-between md:justify-start gap-2">
          <div className="w-full md:w-auto flex items-center gap-2">
            <div className="w-28 sm:w-32 flex-shrink-0">
              <Select
                options={searchList}
                value={searchList.find((i) => i.value == searchBy) || ""}
                styles={customStyles}
                className={`text-xs capitalize 2xl:text-sm font-medium`}
                onChange={handleSearch}
                menuPortalTarget={document.body}
              />
            </div>
            <div className="flex-1 min-w-0">
              <SearchBar
                handleChange={(e) => {
                  setParams({ ...params, search: e.target.value, page: 1 });
                  setPage(1);
                }}
                value={params.search}
              />
            </div>
          </div>

          <div className="hidden md:flex items-center gap-2">
            {/* Table / Card View Toggle (Hidden on mobile < 1024px) */}
            <ViewToggle
              viewMode={effectiveViewMode}
              onViewChange={(mode) => setViewMode(mode)}
              storageKey="viewMode"
            />
            <FilterButton handleClick={() => setShowFilterDialog(true)} showLabel={false} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" showLabel={false} />
            )}
            {GetRole() && (
              <ExportButton handleClick={() => setShowExport(true)} showLabel={false} />
            )}
            {GetRole() && <ImportButton handleClick={handleImportClick} showLabel={false} />}
            {GetAccess("suppliers_create") && (
              <Link to="/procurement/suppliers/create/">
                <CreateButton label="Supplier" />
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* Credit / Advance Summary Stats */}
      <div className="flex flex-wrap gap-4 items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200/60 shadow-sm mt-4 select-none">
        <p className="text-xs font-bold text-gray-500 uppercase tracking-wider">
          Suppliers: <span className="text-gray-800 font-extrabold">{totalCount || 0}</span>
        </p>
        <div className="hidden sm:block w-[1px] h-4 bg-gray-200" />
        <p className="text-xs font-bold text-gray-500 uppercase tracking-wider">
          Credit: <span className="text-rose-500 font-extrabold">{credit || 0}</span>
        </p>
        <div className="hidden sm:block w-[1px] h-4 bg-gray-200" />
        <p className="text-xs font-bold text-gray-500 uppercase tracking-wider">
          Advance: <span className="text-blue-600 font-extrabold">{advance || 0}</span>
        </p>
      </div>

      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        height="h-[calc(100vh-204px)]"
        headers={[
          { title: "ID", width: "60px" },
          { title: "Company", width: "260px" },
          { title: "Category", width: "190px" },
          { title: "Country", width: "120px" },
          { title: "Contact Person", width: "140px" },
          { title: "Mobile", width: "130px" },
          { title: "Email", width: "150px" },
          { title: "Created By", width: "120px" },
          { title: "Action", align: "center", width: "90px" }
        ]}
        renderRow={(row, idx) => (
          <SupplierTableRow
            row={row}
            isSelected={listofNumbers.includes(row.vendorId)}
            onSelect={() => selectOneFunction(row.vendorId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        renderCard={(row, idx) => (
          <SupplierCardWrapper
            row={row}
            isSelected={listofNumbers.includes(row.vendorId)}
            onSelect={() => selectOneFunction(row.vendorId)}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        multiEditLabel="Multi Edit"
      />
      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[520px] md:w-[620px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter Supplier</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-3">
              <div className="flex flex-col sm:flex-row flex-wrap -mx-2">
                <FormikSelectTwo
                  type="text"
                  label="Type"
                  placeholder="Choose"
                  Options={vendorType}
                  formik={formik}
                  name="vendorType"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  type="text"
                  label="Category"
                  placeholder="Choose"
                  Options={supplierCat}
                  formik={formik}
                  name="category"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  Options={vendorRating}
                  label="Performance Ratings"
                  placeholder="performanceRatings"
                  formik={formik}
                  name="performanceRating"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  Options={CountryMIN}
                  label="Country"
                  placeholder="Country"
                  formik={formik}
                  name="country"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  Options={user}
                  label="Created By"
                  placeholder="Created By"
                  formik={formik}
                  name="createdBy"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  Options={user}
                  label="Assigned To"
                  placeholder="Assigned To"
                  formik={formik}
                  name="assigned_to"
                  width="w-full sm:w-1/2"
                  px="2"
                />
                <FormikSelectTwo
                  Options={vendorStatus}
                  label="Status"
                  placeholder="Status"
                  formik={formik}
                  name="vendorStatus"
                  width="w-full sm:w-1/2"
                  px="2"
                />
              </div>
              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}

      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-4">
          <div className="animate-scale-in w-[90%] sm:w-[480px] md:w-[520px] max-w-[95vw] max-h-[85vh] relative bg-white py-5 px-6 rounded-xl shadow-2xl overflow-y-auto">
            <div className="w-full flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
              <h2 className="text-sm sm:text-base font-semibold text-gray-800">
                Export Data
              </h2>
              <div
                className="cursor-pointer text-gray-400 hover:text-gray-600 transition-colors"
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className="w-full flex flex-wrap">
                <div className="w-full flex items-center justify-start gap-4 py-2 mb-2">
                  <div className="flex items-center">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-emerald-600 bg-gray-100 border-gray-300 focus:ring-emerald-500 cursor-pointer"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs sm:text-sm font-medium text-gray-800 cursor-pointer"
                    >
                      All Data
                    </label>
                  </div>

                  <div className="flex items-center">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-emerald-600 bg-gray-100 border-gray-300 focus:ring-emerald-500 cursor-pointer"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs sm:text-sm font-medium text-gray-800 cursor-pointer"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <FormikSelectTwo
                      type="text"
                      label="Type"
                      placeholder="Choose"
                      Options={vendorType}
                      formik={ExportFormik}
                      name="vendorType"
                      width="w-full "
                    />{" "}
                    <FormikSelectTwo
                      type="text"
                      label="Category"
                      placeholder="Choose"
                      Options={supplierCat}
                      formik={ExportFormik}
                      name="category"
                      width="w-full "
                    />
                    <FormikSelectTwo
                      Options={vendorRating}
                      label="Performance Ratings"
                      placeholder="performanceRatings"
                      formik={ExportFormik}
                      name="performanceRating"
                      width="w-full "
                    />
                    <FormikSelectTwo
                      Options={CountryMIN}
                      label="Country"
                      placeholder="Country"
                      formik={ExportFormik}
                      name="country"
                      width="w-full"
                    />
                    <FormikSelectTwo
                      Options={user}
                      label="Created By"
                      placeholder="Created By"
                      formik={ExportFormik}
                      name="createdBy"
                      width="w-full "
                    />
                    <FormikSelectTwo
                      Options={user}
                      label="Assigned To"
                      placeholder="Assigned To"
                      formik={ExportFormik}
                      name="assigned_to"
                      width="w-full "
                    />
                    <FormikSelectTwo
                      Options={vendorStatus}
                      label="Status"
                      placeholder="Status"
                      formik={ExportFormik}
                      name="vendorStatus"
                      width="w-full "
                    />
                  </>
                )}
                <div className="flex w-full justify-end gap-3 pt-4 mt-4 border-t border-gray-100">
                  <CancelButton handleClick={() => setShowExport(false)} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (
        <Importdoc
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
      {showEdit && (
        <MultiEdit
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
    </div>
  );
}
export default SuppliersIndex;
